import { useContext, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import PermissionsCheck from './permissionsCheck';
import { routes } from './allRoutes';
import { AuthCtx } from '../context/AuthCtxProvider';

const AuthRoute = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isLoading, isSignedIn, userType } = useContext(AuthCtx);

    useEffect(() => {
        const redirectToDashboard = [routes.login, routes.forgotPassword, '/'];

        // redirect to login, if not logged
        if (!isSignedIn && !isLoading) {
            return navigate(routes.login);
        }

        // redirect to dashboard, if logged in
        if (!isLoading && isSignedIn && redirectToDashboard.includes(location.pathname)) {
            if (userType === 'superAdmin' || userType === 'adminStaff') {
                return navigate(routes.dashboard);
            } else {
                return navigate(routes.orgDashboard);
            }
        }
    }, [navigate, isSignedIn, isLoading, location.pathname]);

    return (
        <PermissionsCheck>
            <Outlet />
        </PermissionsCheck>
    );
};

export default AuthRoute;
